import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { S1ButtonType } from '../s1-button/s1-button.component';

export enum S1InputFileType {
  image = "image/*",
  video = "video/*",
  audio = "audio/*",
  png = "image/png",
  pdf = ".pdf",
  csv = ".csv",
  xls = "application/vnd.ms-excel",
  xlsx = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
}

@Component({
  selector: 's1-input-file',
  templateUrl: './s1-input-file.component.html',
  styleUrls: ['./s1-input-file.component.scss']
})
export class S1InputFile implements OnInit {

  @Output() newFiles = new EventEmitter<FileList>();
  @Input() disabled: boolean;
  @Input() label: string = "'s1.button.selectAttachments'";
  @Input() set acceptedFiles(newValue: S1InputFile[]) {
    this._acceptedFilesStr = newValue?.join(",");
  }

  _acceptedFilesStr: string;
  s1ButtonType = S1ButtonType;

  constructor() { }

  ngOnInit(): void { }

  addFiles(files: FileList) {
    this.newFiles.emit(files);
  }

}
